export const AppMenuApiUrls = {
  deleteProfilePic: "user/deleteProfilePic",
};

export default class appMenuAPI {
  constructor(httpsClient, cache) {
    this.httpsClient = httpsClient;
    this.cache = cache;
  }

  async deleteProfilePic(data, token) {
    return this.get(AppMenuApiUrls.deleteProfilePic, data, token);
  }

  async get(url, data, token, eAlert, sAlert) {
    return await this.httpsClient.get(url, data, token, eAlert, sAlert);
  }

  async post(url, data, token, eAlert, sAlert) {
    return await this.httpsClient.post(url, data, token, eAlert, sAlert);
  }
}
